import alertify from "alertifyjs";
import "alertifyjs/build/css/alertify.css";

export default async function createObjetivo(status) {
  const endpoint = localStorage.getItem("endpoint");
  const url = endpoint + "adm_clasificacionitemplan/clareferente";

  const js = JSON.stringify(status);

  try {
    const config = { method: "POST", headers: {}, body: js };
    const response = await fetch(url, config);
    const json = await response.json();

    if (json.message === "Se agregó el referente correctamente") {
      alertify.set("alert", "position", "bottom-right");
      alertify.set("notifier", "delay", 5.0);
      alertify.success("Registro Creado");
    } else {
      alertify.set("alert", "position", "bottom-right");
      alertify.set("notifier", "delay", 5.0);
      alertify.error("No fue posible crear el elemento");
    }
  } catch (error) {
    console.log("Error" + error);
  }
}
